module.exports = __webpack_public_path__ + "img/cgjz-8.f18e962f.jpg";